// extracted by mini-css-extract-plugin
export default {"melodyVideo":"tN-z","isFullWidth":"uN-z","landingPageVideo":"vN-z","play":"wN-z","iframeVideo":"xN-z","playHidden":"yN-z","fullwidth":"zN-z"};